import React, { cloneElement } from "react";
import { Container } from "components/shared";
import { Card } from "components/ui";
import Logo from "components/template/Logo";
import BG from "./endless-constellation.png";

const bgSVG =
  "<svg xmlns='http://www.w3.org/2000/svg'  width='400' height='400' viewBox='0 0 800 800'><rect fill='#F3F4F6' width='800' height='800'/><g fill='none' stroke='#E3CAAC'  stroke-width='1'><path d='M769 229L1037 260.9M927 880L731 737 520 660 309 538 40 599 295 764 126.5 879.5 40 599-197 493 102 382-31 229 126.5 79.5-69-63'/><path d='M-31 229L237 261 390 382 603 493 308.5 537.5 101.5 381.5M370 905L295 764'/><path d='M520 660L578 842 731 737 840 599 603 493 520 660 295 764 309 538 390 382 539 269 769 229 577.5 41.5 370 105 295 -36 126.5 79.5 237 261 102 382 40 599 -69 737 127 880'/><path d='M520-140L578.5 42.5 731-63M603 493L539 269 237 261 370 105M902 382L539 269M390 382L102 382'/><path d='M-222 42L126.5 79.5 370 105 539 269 577.5 41.5 927 80 769 229 902 382 603 493 731 737M295-36L577.5 41.5M578 842L295 764M40-201L127 80M102 382L-261 269'/></g><g  fill='#FEDCB4'><circle  cx='769' cy='229' r='5'/><circle  cx='539' cy='269' r='5'/><circle  cx='603' cy='493' r='5'/><circle  cx='731' cy='737' r='5'/><circle  cx='520' cy='660' r='5'/><circle  cx='309' cy='538' r='5'/><circle  cx='295' cy='764' r='5'/><circle  cx='40' cy='599' r='5'/><circle  cx='102' cy='382' r='5'/><circle  cx='127' cy='80' r='5'/><circle  cx='370' cy='105' r='5'/><circle  cx='578' cy='42' r='5'/><circle  cx='237' cy='261' r='5'/><circle  cx='390' cy='382' r='5'/></g></svg>";

const Simple = ({ children, content, ...rest }) => {
  return (
    <>
      {/* <svg
        id="visual"
        className="absolute left-0 h-full right-0 top-0 bottom-0 w-full"
        viewBox="0 0 900 600"
        width="900"
        height="600"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
      >
        <g>
          <g transform="translate(780 7)">
            <path
              d="M0 -132.4L114.7 -66.2L114.7 66.2L0 132.4L-114.7 66.2L-114.7 -66.2Z"
              fill="#efe6df"
            ></path>
          </g>
          <g transform="translate(883 315)">
            <path
              d="M0 -36L31.2 -18L31.2 18L0 36L-31.2 18L-31.2 -18Z"
              fill="#efe6df"
            ></path>
          </g>
          <g transform="translate(152 571)">
            <path
              d="M0 -59L51.1 -29.5L51.1 29.5L0 59L-51.1 29.5L-51.1 -29.5Z"
              fill="#efe6df"
            ></path>
          </g>
          <g transform="translate(322 245)">
            <path
              d="M0 -105L90.9 -52.5L90.9 52.5L0 105L-90.9 52.5L-90.9 -52.5Z"
              fill="#efe6df"
            ></path>
          </g>
          <g transform="translate(544 560)">
            <path
              d="M0 -95L82.3 -47.5L82.3 47.5L0 95L-82.3 47.5L-82.3 -47.5Z"
              fill="#efe6df"
            ></path>
          </g>
          <g transform="translate(50 306)">
            <path
              d="M0 -56L48.5 -28L48.5 28L0 56L-48.5 28L-48.5 -28Z"
              fill="#efe6df"
            ></path>
          </g>
          <g transform="translate(9 32)">
            <path
              d="M0 -117L101.3 -58.5L101.3 58.5L0 117L-101.3 58.5L-101.3 -58.5Z"
              fill="#efe6df"
            ></path>
          </g>
          <g transform="translate(456 14)">
            <path
              d="M0 -32L27.7 -16L27.7 16L0 32L-27.7 16L-27.7 -16Z"
              fill="#efe6df"
            ></path>
          </g>
        </g>
      </svg> */}
      {/* <svg
        id="visual"
        className="absolute left-0 h-full right-0 top-0 bottom-0 w-full"
        viewBox="0 0 900 600"
        width="900"
        height="600"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
      >
        <g>
          <g transform="translate(598 224)">
            <path
              d="M0 -182L157.6 -91L157.6 91L0 182L-157.6 91L-157.6 -91Z"
              fill="#efe6df"
            ></path>
          </g>
          <g transform="translate(886 466)">
            <path
              d="M0 -158L136.8 -79L136.8 79L0 158L-136.8 79L-136.8 -79Z"
              fill="#efe6df"
            ></path>
          </g>
          <g transform="translate(105 444)">
            <path
              d="M0 -139L120.4 -69.5L120.4 69.5L0 139L-120.4 69.5L-120.4 -69.5Z"
              fill="#efe6df"
            ></path>
          </g>
          <g transform="translate(501 584)">
            <path
              d="M0 -149L129 -74.5L129 74.5L0 149L-129 74.5L-129 -74.5Z"
              fill="#efe6df"
            ></path>
          </g>
          <g transform="translate(167 82)">
            <path
              d="M0 -39L33.8 -19.5L33.8 19.5L0 39L-33.8 19.5L-33.8 -19.5Z"
              fill="#efe6df"
            ></path>
          </g>
        </g>
      </svg> */}

      <div className="h-full relative p-4 py-12 sm:p-12">
        <Container className="flex flex-col flex-auto items-center justify-center min-w-0 h-full">
          <Card className="min-w-[320px] md:min-w-[450px]" bodyClass="md:p-10">
            <div className="text-center">
              <Logo type="streamline" imgClass="mx-auto" />
            </div>
            <div className="text-center">
              {content}
              {children
                ? cloneElement(children, {
                    contentClassName: "text-center",
                    ...rest,
                  })
                : null}
            </div>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default Simple;
